import styles from './alt_button.module.scss';
import {Link} from 'react-router-dom';
import React from 'react';
import {classNames} from '../../support/classnames.ts';
import formFooterStyles from '../form_footer/form_footer.module.scss';
import {ButtonColorType} from '../../enums/button_color_type.ts';
import {ButtonPosition} from '../../enums/button_position.ts';

interface OwnProps {
    className?: string;
    to?: string;
    type?: 'button' | 'submit' | 'reset';
    colorType?: ButtonColorType;
    position?: ButtonPosition;
    disabled?: boolean;
    noBorder?: boolean;
    inverse?: boolean;
    loading?: boolean;
    preventScrollReset?: boolean;
    form?: string;
    target?: string;
    onClick?: () => void;
    children: React.ReactNode;
}

export function AltButton({
    className,
    to,
    type,
    colorType,
    position,
    children,
    disabled,
    noBorder,
    inverse,
    loading,
    preventScrollReset,
    form,
    target,
    onClick,
}: OwnProps) {
    if (to) {
        return (
            <Link
                target={target}
                to={to}
                className={classNames(className, styles.alt_button, {
                    [styles.disabled]: disabled,
                    [styles.loading]: loading,
                    [styles.no_border]: noBorder,
                    [styles.inverse]: inverse,
                    [styles.black]: colorType === ButtonColorType.Black,
                    [styles.green]: colorType === ButtonColorType.Green,
                    [formFooterStyles.left]: position === ButtonPosition.Left,
                    [formFooterStyles.right]: position === ButtonPosition.Right,
                })}
                preventScrollReset={preventScrollReset ?? false}
                viewTransition={true}
            >
                {children}
            </Link>
        );
    }

    return (
        <button
            className={classNames(className, styles.alt_button, {
                [styles.disabled]: disabled,
                [styles.no_border]: noBorder,
                [styles.inverse]: inverse,
                [styles.black]: colorType === ButtonColorType.Black,
                [styles.green]: colorType === ButtonColorType.Green,
                [formFooterStyles.left]: position === ButtonPosition.Left,
                [formFooterStyles.right]: position === ButtonPosition.Right,
            })}
            type={type ?? 'submit'}
            disabled={disabled}
            onClick={onClick}
            form={form}
        >
            {children}
        </button>
    );
}
